@use "ui/styles/colors";
@use "ui/styles/colorsOld";
@use "ui/styles/fonts";

.wrapper {
  margin: 16px 0 8px;

  :global {
    .container {
      min-height: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .hr {
      margin-top: 8px;
    }

    .header-left,
    .header-right {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    .header-title {
      font-size: fonts.$base;
      font-weight: fonts.$medium;
      line-height: 100%;
    }

    .header-subtitle {
      font-size: 12px;
      color: colorsOld.$stoneDark;
    }

    a {
      font-weight: bold;
      color: colorsOld.$sapphireLight;
    }
  }
}

a.headerLink {
  color: colorsOld.$stoneDarkX1;
  svg {
    margin-left: 9px;
  }
}

.buttonAndToggleWrapper {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 15px;
}

.headerSearchWrapper {
  display: flex;
  align-items: center;
  margin-right: auto;
  margin-left: 1em;
  border-left: 1px solid colorsOld.$stoneLightX1;
  height: 20px;

  &.noTitle {
    margin-left: 0;
    border-left: none;
  }
}

.sticky {
  position: sticky;
  top: 0;
  background-color: colorsOld.$stoneLightX5;
  z-index: 1000;
}

.divider {
  width: 1px;
  height: 18px;
  margin: 0 18px;
  background-color: colors.$gray40;
}
